var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pea-table',{attrs:{"tableData":_vm.tableData,"page":_vm.page,"pageSize":_vm.pageSize,"resultTotal":_vm.resultTotal,"status":_vm.status,"tableLoading":_vm.tableLoading,"selectRow":_vm.selectRow,"currentChange":_vm.getPeas,"rowStyle":_vm.rowStyle}})
}
var staticRenderFns = []

export { render, staticRenderFns }